{
  "rowTypeName": {
    "companies": "Companies",
    "contacts": "Contacts",
    "key_activities": "Key Activities",
    "projects_opportunities": "Projects Opportunities",
    "opportunities": "Opportunities",
    "generic_items": "Items",
    "key_activity_dashboard": "Key Activities"
  },
  "actions": {
    "add_opportunity": "Add Opportunity",
    "add_activity": "Add Activity",
    "add_company": "Add Company",
    "add_contact": "Add Contact",
    "add_generic_item": "Add Item"
  },
  "more_actions": {
    "more": "More",
    "large_list_view_title": "Large List View",
    "large_list_view_description": "Improved performance, limited search, sort and filters.",
    "removed_history": "Removed History",
    "list_settings": "List Settings"
  },
  "export": {
    "title": "Export",
    "confirmationModal": {
      "content": "Exporting a large list will include all {{rowTypeName}} and may take some time. To speed up the process, consider applying a filter. Are you sure you want to proceed with exporting all {{rowTypeName}} without any filters?"
    }
  }
}
